import React, { useState, useEffect } from 'react';
import styles from './ReportStudio.module.css';
import { FiDownload } from 'react-icons/fi';

const ReportStudio = () => {
    const [loading, setLoading] = useState(false);
    const [completedCount, setCompletedCount] = useState(0);
    const [draftsCount, setDraftsCount] = useState(0);
    const [message, setMessage] = useState({ text: '', type: '' });

    const getToken = () => {
        return localStorage.getItem('token');
    };

    const fetchCounts = async () => {
        try {
            const token = getToken();
            const response = await fetch('https://lulliconazole.onrender.com/api/studies/total-reports', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            const data = await response.json();
            if (data.success) {
                setCompletedCount(data.data.totalCompleted || 0);
                setDraftsCount(data.data.totalDrafts || 0);
            }
        } catch (error) {
            console.error('Error fetching counts:', error);
        }
    };

    const handleExport = async (type) => {
        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const token = getToken();
            const response = await fetch('https://lulliconazole.onrender.com/api/studies/export', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ type })
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const date = new Date().toISOString().split('T')[0];
            link.download = `${type}-submissions-${date}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setMessage({ text: 'Export successful!', type: 'success' });
            setTimeout(() => setMessage({ text: '', type: '' }), 3000);

        } catch (error) {
            setMessage({ text: `Export failed: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCounts();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titleSection}>
                    <h1 className={styles.title}>
                        <FiDownload className={styles.titleIcon} />
                        Export Data to Excel
                    </h1>
                    <p className={styles.subtitle}>
                        Download survey submissions to Excel format for further analysis
                    </p>
                </div>
            </div>

            {message.text && (
                <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
                    {message.text}
                </div>
            )}

            <div className={styles.exportCards}>
                <div className={styles.card}>
                    <h3 className={styles.cardTitle}>Completed Only</h3>
                    <p className={styles.cardCount}>{completedCount} completed records</p>
                    <button
                        className={styles.exportButtonPrimary}
                        onClick={() => handleExport('submitted')}
                        disabled={loading || completedCount === 0}
                    >
                        <FiDownload />
                        Export Completed
                    </button>
                </div>

                <div className={styles.card}>
                    <h3 className={styles.cardTitle}>Drafts Only</h3>
                    <p className={styles.cardCount}>{draftsCount} draft records</p>
                    <button
                        className={styles.exportButtonSecondary}
                        onClick={() => handleExport('draft')}
                        disabled={loading || draftsCount === 0}
                    >
                        <FiDownload />
                        Export Drafts
                    </button>
                </div>
            </div>

            <div className={styles.infoSection}>
                <h4 className={styles.infoTitle}>Export Information</h4>
                <ul className={styles.infoList}>
                    <li>Files are named with export date for easy tracking</li>
                    <li>Compatible with Microsoft Excel, Google Sheets, and other spreadsheet applications</li>
                </ul>
            </div>
        </div>
    );
};

export default ReportStudio;
